// extracted by mini-css-extract-plugin
export default {"wrapper":"e0z9a","wrapper__title":"F4wuz"};